import { jsx as _jsx } from "react/jsx-runtime";
/**
 * 错误处理上下文
 * 为应用提供错误处理服务访问
 *
 * 核心功能：
 * 1. 提供错误处理服务的上下文
 * 2. 提供错误处理提供者组件
 * 3. 通过上下文机制向组件树提供错误处理功能
 */
import { createContext } from 'react';
import { ErrorHandlerService } from '../service/error-handler.service.js';
/**
 * 创建错误处理上下文
 * 初始值为null，将在Provider中设置
 */
export const ErrorContext = createContext(null);
/**
 * 错误处理服务提供者组件
 * 为组件树提供错误处理服务访问
 */
export const ErrorProvider = ({ children }) => {
    // 获取错误处理服务单例
    const errorHandler = ErrorHandlerService.getInstance();
    return _jsx(ErrorContext.Provider, { value: errorHandler, children: children });
};
/**
 * 默认导出提供者组件
 * 便于导入使用
 */
export default ErrorProvider;
//# sourceMappingURL=ErrorContext.js.map